import { useModalSheet } from 'src/components/contexts/ModalSheetContext'
import CloseIcon from 'src/images/icons/CloseIcon'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { MINI_PDP_EXPERIMENT_ID } from 'src/components/common/StatsigExposure/StatsigExposure'
import { Statsig } from 'src/sdk/statsig'

import type { ProductItem } from '../../types/productItem'
import type { Product } from '../../types/product'
import { ModalProductToAdd } from '../ModalProductToAdd'
import type { AddToCartFn } from './useAddToCartLogic'
import { dispatchQuickViewEvent } from '../ModalProductToAdd/quickViewEvents'

// Helper para enviar evento de botão do modal
const sendCloseButtonEvent = (
  standardObject: Record<string, unknown>,
  productObject: Record<string, unknown>
) => {
  dispatchAmplitudeEvent({
    eventName: 'Click Button Modal',
    eventData: {
      ...standardObject,
      ...productObject,
      'modal nome': 'compra pela vitrine/plp',
    },
  })
}

export function useSkuSelectionModal(params: {
  product: Product
  currentSku: ProductItem
  Images: ProductItem['images']
  isLoading: boolean
  addToCartFn: AddToCartFn
  isMobile: boolean | undefined
  standardObject: Record<string, unknown> | null
  productObject: Record<string, unknown> | null
}) {
  const { openModal, closeModal } = useModalSheet()
  const isMiniPdpExperimentEnabled = Statsig.useStatsigFeatureGateValue(
    MINI_PDP_EXPERIMENT_ID
  )

  const {
    product,
    currentSku,
    Images,
    isLoading,
    addToCartFn,
    isMobile,
    standardObject,
    productObject,
  } = params

  const sendQuickViewEvent = () => {
    if (isMiniPdpExperimentEnabled) {
      dispatchQuickViewEvent('Quick View Closed', {
        standardObject,
        productObject,
      })
    }
  }

  const openSkuSelectionModal = (onCloseCallback?: () => void) => {
    const defaultOnClose = () => {
      sendQuickViewEvent()

      if (standardObject && productObject) {
        sendCloseButtonEvent(standardObject, productObject)
      }
    }

    openModal({
      content: (
        <ModalProductToAdd
          product={product}
          currentProduct={currentSku}
          Images={Images}
          addToCartFn={addToCartFn}
          isLoading={isLoading}
        />
      ),
      contentHasInternalScroll: isMiniPdpExperimentEnabled,
      height: '90dvh',
      width: isMiniPdpExperimentEnabled ? '511px' : undefined,
      title:
        isMiniPdpExperimentEnabled || isMobile ? ' ' : 'Adicionar ao carrinho',
      header: isMiniPdpExperimentEnabled
        ? {
            isVisible: true,
            component: (
              <div className="absolute right-4 top-4 z-10">
                <button
                  type="button"
                  aria-label="Fechar modal"
                  data-testid="modal-sheet-close-button"
                  onClick={() => {
                    sendQuickViewEvent()
                    closeModal()
                  }}
                >
                  <CloseIcon />
                </button>
              </div>
            ),
          }
        : undefined,
      onClose: onCloseCallback ?? defaultOnClose,
    })
  }

  return { openSkuSelectionModal }
}
